export default __webpack_public_path__ + "static/media/trus8.f9e88857.png";